// Tiny localStorage-based A/B utility.
// Persistent per-visitor variant assignment for the sticky CTA.

const KEY = "rp_cta_variant";

export const VARIANTS = {
  A: { id: "A", label: "Get a Shoot Quote" },
  B: { id: "B", label: "Estimate My Shoot" },
};

/**
 * Returns the persistent CTA variant for this visitor.
 * Assigns a fresh 50/50 split on first call and caches it in localStorage.
 * SSR-safe — returns variant A as default when window isn't defined.
 */
export const getCtaVariant = () => {
  if (typeof window === "undefined") return VARIANTS.A;
  try {
    let id = window.localStorage.getItem(KEY);
    if (id !== "A" && id !== "B") {
      id = Math.random() < 0.5 ? "A" : "B";
      window.localStorage.setItem(KEY, id);
    }
    return VARIANTS[id];
  } catch {
    // localStorage blocked (private mode, etc.) — default to A
    return VARIANTS.A;
  }
};
